export const experimentalGroups = ["WOLFRI", "AERIAL", "AERIA1", "SUNCHE", "RIGHTA", "RIGTES", "PRODUC"];
